import cx from "classnames";
import React from "react";

import styles from "../ProfilePage.module.scss";

export interface UsageTableRow {
  key: string;
  cells: string[];
}

interface UsageTableProps {
  columns: string[];
  rows: UsageTableRow[];
}

const UsageTable: React.FC<UsageTableProps> = ({ columns, rows }) => (
  <div className={styles.developerUsageTable}>
    <div
      className={cx(
        styles.developerUsageTableRow,
        styles.developerUsageTableHeader,
      )}
    >
      {columns.map((column) => (
        <div key={column}>{column}</div>
      ))}
    </div>
    {rows.map((row) => (
      <div key={row.key} className={styles.developerUsageTableRow}>
        {row.cells.map((cell, index) => (
          <div
            key={`${row.key}-${index}`}
            className={styles.developerUsageTableCell}
          >
            {cell}
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default UsageTable;
